import { FETCH_INITIAL_HISTORY_REQUEST, FETCH_INITIAL_HISTORY_FAILURE, FETCH_INITIAL_HISTORY_SUCCESS, FETCH_NEXT_HISTORY_REQUEST, FETCH_NEXT_HISTORY_FAILURE, FETCH_NEXT_HISTORY_SUCCESS, ADD_NEW_HISTORY_ITEM, } from './history-actions';
import { checkIfRevisionIsLocal, createLocalHistoryRevision } from './history-utils';
import { isRichContentEqual } from '@wix/ricos';
export const historyReducer = (state, actions) => {
    switch (actions.type) {
        case ADD_NEW_HISTORY_ITEM: {
            const { commentId, comment, owner } = actions.payload;
            const commentHistory = state.historyById[commentId];
            return {
                ...state,
                historyById: {
                    ...state.historyById,
                    [commentId]: {
                        initialFetchDone: commentHistory?.initialFetchDone ?? false,
                        isPending: false,
                        nextCursor: commentHistory?.nextCursor ?? null,
                        items: [createLocalHistoryRevision(comment, owner), ...(commentHistory?.items ?? [])],
                    },
                },
            };
        }
        case FETCH_INITIAL_HISTORY_REQUEST:
        case FETCH_NEXT_HISTORY_REQUEST: {
            const { commentId } = actions.payload;
            const commentHistory = state.historyById[commentId];
            return {
                ...state,
                historyById: {
                    ...state.historyById,
                    [commentId]: {
                        initialFetchDone: commentHistory?.initialFetchDone ?? true,
                        nextCursor: commentHistory?.nextCursor ?? null,
                        items: commentHistory?.items ?? [],
                        isPending: true,
                    },
                },
            };
        }
        case FETCH_NEXT_HISTORY_FAILURE:
        case FETCH_INITIAL_HISTORY_FAILURE: {
            const { commentId } = actions.payload;
            const commentHistory = state.historyById[commentId];
            return {
                ...state,
                historyById: {
                    ...state.historyById,
                    [commentId]: {
                        initialFetchDone: commentHistory?.initialFetchDone ?? false,
                        items: commentHistory?.items ?? [],
                        nextCursor: commentHistory?.nextCursor ?? null,
                        isPending: false,
                    },
                },
            };
        }
        case FETCH_NEXT_HISTORY_SUCCESS: {
            const { commentId, nextCursor, history } = actions.payload;
            const currentItems = state.historyById[commentId]?.items ?? [];
            return {
                ...state,
                historyById: {
                    ...state.historyById,
                    [commentId]: {
                        initialFetchDone: true,
                        items: [...currentItems, ...history],
                        nextCursor,
                        isPending: false,
                    },
                },
            };
        }
        case FETCH_INITIAL_HISTORY_SUCCESS: {
            const { commentId, nextCursor, history } = actions.payload;
            const commentHistory = state.historyById[commentId];
            return {
                ...state,
                historyById: {
                    ...state.historyById,
                    [commentId]: {
                        initialFetchDone: commentHistory?.initialFetchDone ?? true,
                        items: mergeHistory(commentHistory?.items ?? [], history),
                        nextCursor,
                        isPending: false,
                    },
                },
            };
        }
        default:
            return state;
    }
};
const mergeHistory = (currentHistory, newHistory) => {
    const merged = [...currentHistory, ...newHistory];
    return merged.filter((item) => {
        if (checkIfRevisionIsLocal(item.revisionId)) {
            return !newHistory.find((newItem) => newItem.createdAt === item.createdAt && isRichContentEqual(newItem.content, item.content));
        }
        return true;
    });
};
//# sourceMappingURL=history-reducer.js.map